import { useRouter } from 'next/router';
import { useState } from 'react';

import Autosuggest from '~components/Autosuggest';
import { useAutosuggest } from '~components/Autosuggest/helper';
import { ICompany } from '~types/company';
import { setGtmDataLayer } from '~utils/common/thirdPartyEvent';

import BannerText from './BannerText';
import RealTime from './Realtime';
import * as S from './style';

function TopBanner() {
  const router = useRouter();
  const { isSearching, handleOpenSuggest } = useAutosuggest();
  const [ref, setRef] = useState<HTMLDivElement | null>(null);
  const [value, setValue] = useState<ICompany>({
    PK_NM_HASH: '',
    location: '',
    locationCode: '',
    name: '',
  });

  return (
    <S.Wrapper>
      <BannerText />
      <S.InputWrapper isSearching={isSearching && !!ref}>
        <span>
          <img src='/images/search.png' alt='search-icon' />
        </span>
        <Autosuggest
          value={value}
          isForm
          setValue={(company) => setValue(company)}
          handleChange={(value: ICompany, type, query) => {
            router.push(`/company/${value.PK_NM_HASH}`);
            handleOpenSuggest(false);
            setGtmDataLayer('search__enter', {
              searchValue: query,
            });
          }}
          ref={(newRef) => setRef(newRef)}
          renderInput={
            <S.Input
              placeholder='기업을 검색해보세요.'
              onChange={() => {
                handleOpenSuggest(true);
              }}
              onBlur={() => handleOpenSuggest(false)}
              onFocus={() => handleOpenSuggest(true)}
            />
          }
          inlineCss={S.inlineCss}
          listCss={S.listCss}
          onSubmit={(data, search) => {
            router.push(`/company/${data.PK_NM_HASH}`);
            setGtmDataLayer('search__enter', {
              searchValue: search,
            });
          }}
        />
      </S.InputWrapper>
      <RealTime />
    </S.Wrapper>
  );
}

export default TopBanner;
